import React from "react";
import styles from "./DepartmentCard.module.css";
import { IDepartmentCardProps } from "@model/Department.model";
import EditIcon from "Utils/Assets/SVGs/EditIcon";
import TrashIcon from "Utils/Assets/SVGs/TrashIcon";
import UserIcon from "Utils/Assets/SVGs/UserIcon";
import CalendarIcon from "Utils/Assets/SVGs/CalendarIcon";
import { useDepartmentCard } from "../../../Logic/Functions/Hooks/useDepartmentCard";
const DepartmentCard: React.FC<IDepartmentCardProps> = ({
  department,
  onOpen,
  onEdit,
  onDelete,
}) => {
  const { handleCardClick, handleKeyDown, stop, headLabel, handleHeadClick } =
    useDepartmentCard({ department, onOpen });

  return (
    <article
      className={`${styles.dcCard} ${onOpen ? styles.dcClickable : ""}`}
      data-testid="department-card"
      onClick={handleCardClick}
      role={onOpen ? "button" : undefined}
      tabIndex={onOpen ? 0 : -1}
      onKeyDown={handleKeyDown}
      aria-label={onOpen ? `Open ${department.name}` : undefined}
    >
      <div className={styles.dcHead}>
        <h3 className={styles.dcTitle} title={department.name}>
          {department.name}
        </h3>

        <div className={styles.dcActions} onClick={stop}>
          {onEdit && (
            <button
              type="button"
              className={styles.dcActionBtn}
              onClick={() => onEdit(department.id)}
              data-testid="department-edit"
              aria-label={`Edit ${department.name}`}
            >
              <EditIcon className={styles.dcIcon} aria-hidden="true" />
              <span>Edit</span>
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              className={styles.dcActionBtnDanger}
              onClick={() => onDelete(department.id)}
              data-testid="department-delete"
              aria-label={`Delete ${department.name}`}
            >
              <TrashIcon className={styles.dcDelete} aria-hidden="true" />
              <span>Delete</span>
            </button>
          )}
        </div>
      </div>

      {department.description && (
        <p className={styles.dcDescription}>{department.description}</p>
      )}

      <div className={styles.dcMeta}>
        <div className={styles.dcMetaRow}>
          <div className={styles.dcMetaLabel}>
            <UserIcon className={styles.dcIconMeta} aria-hidden="true" />
            <span>Head of department :</span>
          </div>
          <div className={styles.dcMetaValue}>
            <button
              type="button"
              className={styles.dcHeadLink}
              onClick={handleHeadClick}
              disabled={!department.headOfDepartmentUserId}
            >
              {headLabel}
            </button>
          </div>
        </div>

        {department.createdAt && (
          <div className={styles.dcMetaRow}>
            <div className={styles.dcMetaLabel}>
              <CalendarIcon className={styles.dcIconMeta} aria-hidden="true" />
              <span>Created :</span>
            </div>
            <div className={styles.dcMetaValue}>
              {new Date(department.createdAt).toLocaleString()}
            </div>
          </div>
        )}

        {department.lastModifiedAt && (
          <div className={styles.dcMetaRow}>
            <div className={styles.dcMetaLabel}>
              <CalendarIcon className={styles.dcIconMeta} aria-hidden="true" />
              <span>Updated :</span>
            </div>
            <div className={styles.dcMetaValue}>
              {new Date(department.lastModifiedAt).toLocaleString()}
            </div>
          </div>
        )}
      </div>
    </article>
  );
};

export default DepartmentCard;
